import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import Duct from "./components/Duct";


import CustomCursor from "./components/CustomCursor";
import ContactUs from "./components/ContactUs";
import Products from "./pages/Products";
import ProductDetails from "./components/ProductDetails";
import ProjectDetail from "./components/ProjectDetails"
import Projects from "./components/Projects"
import WhoWeAre from "./components/WhoWeAre";
import ButtonDetails from "./pages/ButtonDetails";
import Services from "./components/Services"
import Partner from "./components/Partner";


export default function App() {
  return (

    <BrowserRouter>
      <CustomCursor />
      <Routes>

        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />

        <Route path="/projects" element={<Projects />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product-details" element={<ProductDetails />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/whoweare" element={<WhoWeAre />} />
        <Route path="/service" element={<Services />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/duct" element={<Duct />} />

        {/* ✔ Correct route */}
        <Route path="/buttondetails" element={<ButtonDetails />} />
      </Routes>

    </BrowserRouter>
  );
}
